import { addApiKeyPermissionsMapping, initApiKeysTable } from './js/portal/apikeys';
import { baseApiAxios } from './js/portal/api';
import { CONF } from './js/portal/environment';
import { Datatable } from './Datatable';
import { enableFeatureFlagControlledElements } from './js/portal/feature_flags';
import { linkWithoutSearch } from './js/portal/main';

const tableId = 'apiKeysTable';

export default function LoginManageApiKeysPage() {
  const page = (
    <>
      <div class="row">
        <div class="col-lg-12">
          <div id="form-error" class="alert alert-danger" style="display: none">
            <ul />
          </div>
          <div id="form-success" class="alert alert-success" style="display: none">
            <ul />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="card infobox">
            <div class="card-body">
              <ul class="overview">
                <li class="overview">
                  <i class="fas fa-book" /> The Swagger documentation is available on the APIM portal at{' '}
                  <a
                    href="https://api.bmw.com/apim/portal/api-product/74eafba8-518d-4f07-ae43-d32bec445b05"
                    target="_blank"
                    rel="noopener noreferrer">
                    https://api.bmw.com/apim/portal
                  </a>
                  {'.'}
                </li>
                <li class="overview">
                  <i class="fas fa-key" /> You can copy use API key and use one of the following hosts to communicate
                  with the v1 API endpoints:
                  <ul>
                    <li>
                      External endpoint:{' '}
                      <a href={`${CONF.apimAPIExternalEndpoint}/v1`} target="_blank" rel="noopener noreferrer">
                        {CONF.apimAPIExternalEndpoint}/v1
                      </a>
                    </li>
                    <li>
                      Internal endpoint:{' '}
                      <a href={`${CONF.apimAPIInternalEndpoint}/v1`} target="_blank" rel="noopener noreferrer">
                        {CONF.apimAPIInternalEndpoint}/v1
                      </a>
                    </li>
                    <li>
                      Legacy endpoint:{' '}
                      <a href={CONF.apiUserAPIEndpoint} target="_blank" rel="noopener noreferrer">
                        {CONF.apiUserAPIEndpoint}
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="overview">
                  <i class="fas fa-robot" /> Its not recommended to use a Portal API key for machine2machine
                  communication. To communicate with a machine client to the AWS Self Service Portal, register a M2M
                  client on the{' '}
                  <a
                    href="https://bmwprod.service-now.com/webeam_next?id=wen_home"
                    target="_blank"
                    rel="noopener noreferrer">
                    WEN Portal
                  </a>
                  , subscribe it via the{' '}
                  <a
                    href="https://api.bmw.com/apim/portal/api-product/74eafba8-518d-4f07-ae43-d32bec445b05"
                    target="_blank"
                    rel="noopener noreferrer">
                    APIM portal
                  </a>
                  , and map the M2M Client to a user on{' '}
                  <a href={linkWithoutSearch('#managem2mportalapiaccess')}>this page</a>. Additional information can be
                  found in{' '}
                  <a
                    href="https://developer-home.bmwgroup.net/docs/public-cloud-platform-aws/3_runyourapplication/selfservices/aws_portal_user_api/m2m_api_access/"
                    target="_blank"
                    rel="noopener noreferrer">
                    developer home
                  </a>{' '}
                  and on{' '}
                  <a href="https://atc.bmwgroup.net/confluence/x/FLHgkgE" target="_blank" rel="noopener noreferrer">
                    this confluence page
                  </a>
                  {'.'}
                </li>
                <li class="overview">
                  <a
                    class="nobr"
                    href="https://developer.bmwgroup.net/docs/public-cloud-platform-aws/3_runyourapplication/selfservices/aws_portal_user_api/portal_user_api/"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i class="fas fa-book" /> Developer Portal
                  </a>{' '}
                  <small>(internal Documentation)</small>
                </li>

                <li class="overview feature-flag-api-keys-oauth-client-info d-none">
                  <i class="fas fa-info-circle" /> The v2 API route only supports webEAM OIDC authentication. M2M
                  Clients can obtain an access token via the default WEN supported client credentials flow and use it to
                  access the v2 API route. The v1 API route supports both webEAM OIDC and M2M authentication.
                </li>
                <li class="overview feature-flag-api-keys-oauth-client-info d-none">
                  <i class="fas fa-plug" /> You can also obtain an access token directly with API clients like Postman,
                  Insomnia or Bruno by configuring OAuth 2.0 with Authorization Code grant and PKCE (SHA-256), without a
                  client secret:
                  <ul>
                    <li>
                      Authorization URL:{' '}
                      <code>{`${CONF.authEndpointAlpha}?acr_values=${CONF.webEAMAuthorizeParamsAlpha.acr_values}`}</code>
                    </li>
                    <li>
                      Access Token URL: <code>{CONF.tokenEndpointAlphaAbsolute}</code>
                    </li>
                    <li>
                      Client ID: <code>{CONF.clientIdAlpha}</code>
                    </li>
                    <li>
                      Redirect URL: <code>{CONF.redirectUriAlpha}</code>
                    </li>
                    <li>
                      Scope: <code>{CONF.webEAMAuthorizeParamsAlpha.scope}</code>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="row" id="edit-api-key-form" style="display: none" />
      <div class="row" id="edit-api-key-permissions-form" style="display: none" />

      <Datatable tableId={tableId} />
    </>
  );

  function onPageReady() {
    /**
     * Load data as soon as the whole page is loaded
     */

    initApiKeysTable(tableId, 'portal');
    baseApiAxios
      .postApiKeyData({ action: 'list-api-resources-methods', target: 'portal' })
      .then(addApiKeyPermissionsMapping);

    enableFeatureFlagControlledElements('api-keys.oauth_client_info', 'feature-flag-api-keys-oauth-client-info');
  }

  return [page, onPageReady];
}
